import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box, Typography } from '@mui/material';

type MockupBannerProps = {
    surface: 'Student' | 'Teacher' | 'Public pages';
};

export default function MockupBanner({ surface }: MockupBannerProps) {
    return (
        <Box
            role="status"
            sx={{
                position: 'sticky',
                top: 0,
                zIndex: 1400,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 1,
                px: 2,
                py: 0.75,
                backgroundColor: '#FFF4CC',
                borderBottom: '1px solid #E4C35D',
                color: '#513B00',
            }}
        >
            <InfoOutlinedIcon sx={{ fontSize: 17, flexShrink: 0 }} />
            <Typography
                sx={{
                    fontFamily: 'Inter, sans-serif',
                    fontSize: { xs: 12, sm: 13 },
                    fontWeight: 700,
                    lineHeight: 1.35,
                    textAlign: 'center',
                }}
            >
                {surface === 'Public pages'
                    ? 'Public pages mockup: sample interface; account forms do not submit'
                    : `${surface} mockup: static prototype with fabricated data`}
            </Typography>
        </Box>
    );
}
